<template>
    <v-row justify="center">
        <v-col cols="12" md="4">
            <v-card class="pa-10">
                <h2>Login</h2>
                <div class="grey--text">Masukkan username dan password untuk memulai sesi</div>

                <v-form ref="login" class="my-10" @submit.prevent="handleSubmit">
                    <v-text-field 
                        v-model="req.username" 
                        :rules="textRules('username')"
                        label="Username"
                        filled
                    ></v-text-field>

                    <v-text-field
                        v-model="req.password"
                        :rules="textRules('password')"
                        label="Password"
                        :type="showPassword ? 'text' : 'password'"
                        filled
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPassword = !showPassword"
                    >
                    </v-text-field>

                    <v-btn type="submit" large block color="primary">Submit</v-btn>
                </v-form>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        layout: 'default',
        data() {
            return {
                req: {},
                showPassword: false,
            }
        },
        methods: {
            textRules(text) {
                return [
                    v => !!v || `${text} harus diisi`
                ]
            },
            handleSubmit() {
                if (this.$refs.login.validate()) {
                    this.$root.app.http.post('/api/guru/login', this.req).then((res) => {
                        if (res.error) {
                            this.$root.app.notif((typeof res.message) == 'string' ? res.message : res.message[0], true);
                        } else {
                            this.$root.app.notif(res.message);
                            localStorage.setItem('xid', res.data.id);
                            localStorage.setItem('xlevel', res.data.level);
                            window.location = './';
                        }
                    })
                }
            }
        }
    }
</script>